/*
 *
 * MMPay page reducer
 *
 */

import * as cn from './constants';

const MMPAY_RESTAURANT_TIME_KEY = 'mmpay_restaurant_start_time';
const defaultRestaurantStartTime = '00:00';
const persistedRestaurantStartTime = localStorage.getItem(MMPAY_RESTAURANT_TIME_KEY);

const createMetric = () => ({ value: 0, delta: 0 });

export const initialState = {
  mmpayRestaurantStartTime: persistedRestaurantStartTime ?? defaultRestaurantStartTime,
  scores: {
    error: null,
    loading: false,
    payload: {
      orders: createMetric(),
      amount: createMetric(),
      refund: createMetric(),
      discounts: createMetric(),
      payout: createMetric(),
      payment: createMetric(),
      fees: createMetric(),
      bill_amount: createMetric(),
    },
  },
  dailySummary: {
    loading: false,
    error: null,
    payload: {
      overall: [],
      daily: [],
    },
  },
  transactionsTable: {
    loading: false,
    error: null,
    payload: [],
  },
};

function mmpayReducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case cn.SCORE_INIT:
      return {
        ...state,
        scores: {
          loading: true,
          error: null,
          payload: initialState.scores.payload,
        },
      };

    case cn.SCORE_SUCCESS:
      return {
        ...state,
        scores: {
          loading: false,
          error: null,
          payload,
        },
      };

    case cn.SCORE_ERROR:
      return {
        ...state,
        scores: {
          loading: false,
          error,
          payload: initialState.scores.payload,
        },
      };

    case cn.DAILY_SUMMARY_INIT:
      return {
        ...state,
        dailySummary: {
          loading: true,
          error: null,
          payload: initialState.dailySummary.payload,
        },
      };

    case cn.DAILY_SUMMARY_SUCCESS:
      return {
        ...state,
        dailySummary: {
          loading: false,
          error: null,
          payload,
        },
      };

    case cn.DAILY_SUMMARY_ERROR:
      return {
        ...state,
        dailySummary: {
          loading: false,
          error,
          payload: initialState.dailySummary.payload,
        },
      };

    case cn.TRANSACTIONS_INIT:
      return {
        ...state,
        transactionsTable: {
          loading: true,
          error: null,
          payload: initialState.transactionsTable.payload,
        },
      };

    case cn.TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactionsTable: {
          loading: false,
          error: null,
          payload,
        },
      };

    case cn.TRANSACTIONS_ERROR:
      return {
        ...state,
        transactionsTable: {
          loading: false,
          error,
          payload: initialState.transactionsTable.payload,
        },
      };

    case cn.SET_MMPAY_RESTAURANT_START_TIME:
      if (payload !== state.mmpayRestaurantStartTime) {
        localStorage.setItem(MMPAY_RESTAURANT_TIME_KEY, payload);
      }
      return {
        ...state,
        mmpayRestaurantStartTime: payload,
      };

    default:
      return state;
  }
}

export default mmpayReducer;
